import { RootState } from "../store";

export const cartSelector = (state: RootState) => state.cart;
